<template>
  <h-table-free
    v-if="free"
    :table="table"
    @create="$emit('create', $event)"
    @more="$emit('more', {
      free: true,
      id: table.id,
      event: $event,
    })"
  />
  <h-table-occupied
    v-else
    :table="table"
    :order="order"
    @preview="$emit('preview', $event)"
    @edit="$emit('edit', $event)"
    @more="$emit('more', {
      free: false,
      id: order.id,
      event: $event,
    })"
  />
</template>

<script>
  import HTableFree from './TableFree'
  import HTableOccupied from './TableOccupied'

  export default {
    components: {
      HTableFree,
      HTableOccupied,
    },

    props: {
      table: {
        required: true,
        type: Object,
      },
    },

    computed: {
      order () {
        return this.$store.getters['orders/getByTableId'](this.table.id)
      },
      free () {
        return ! Boolean(this.order)
      },
    },
  }
</script>
